"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedCurrencies = exports.validateCurrencyOptions = exports.validateOptions = exports.transformCurrencyOptions = exports.transformOptions = exports.getCurrencyFormatter = void 0;
const FormatterUtils_1 = require("../FormatterUtils");
const CoreNumberFormatter_1 = require("../lib/CoreNumberFormatter");
const SupportedCurrencies_1 = require("./SupportedCurrencies");
const NumberUtils_1 = require("./NumberUtils");
function getCurrencyFormatter(options) {
    const newOptions = exports.validateOptions(options);
    const intlOptions = exports.transformOptions(newOptions);
    return new CoreNumberFormatter_1.CoreNumberFormatter(newOptions.locale, intlOptions);
}
exports.getCurrencyFormatter = getCurrencyFormatter;
function transformOptions(options) {
    return Object.assign(Object.assign({}, (0, NumberUtils_1.transformNumberOptionsBasic)(options)), exports.transformCurrencyOptions(options));
}
exports.transformOptions = transformOptions;
function transformCurrencyOptions(options) {
    const numberFormatOptions = {};
    numberFormatOptions.style = "currency";
    numberFormatOptions.currency = options.currencyIsoCode;
    numberFormatOptions.currencyDisplay = options.currencyDisplay;
    numberFormatOptions.currencySign = options.currencySign;
    return numberFormatOptions;
}
exports.transformCurrencyOptions = transformCurrencyOptions;
function validateOptions(options) {
    const updatedOptions = Object.assign(Object.assign({}, options), { locale: (0, FormatterUtils_1.getINTLCompatibleLocale)(options.locale) });
    (0, NumberUtils_1.validateNumberOptionsBasic)(updatedOptions);
    exports.validateCurrencyOptions(updatedOptions);
    return updatedOptions;
}
exports.validateOptions = validateOptions;
function validateCurrencyOptions(currencyOptions) {
    const alphabeticRegex = /^[a-z]*$/i;
    if (currencyOptions.currencyIsoCode.length === 3 &&
        alphabeticRegex.test(currencyOptions.currencyIsoCode)) {
        return currencyOptions;
    }
    const errorMessage = `@procore/globalization-toolkit Intl.NumberFormat error for currency ${currencyOptions.currencyIsoCode}. Please use a valid ISO Currency Code.`;
    console.error(errorMessage);
    throw new Error(errorMessage);
}
exports.validateCurrencyOptions = validateCurrencyOptions;
function supportedCurrencies() {
    const currencyCodes = [
        ...Intl.supportedValuesOf("currency"),
        ...SupportedCurrencies_1.IntlPartiallySupportedCurrencies,
    ];
    return currencyCodes.filter((currency) => SupportedCurrencies_1.SupportedCurrencies.includes(currency));
}
exports.supportedCurrencies = supportedCurrencies;
//# sourceMappingURL=CurrencyUtils.js.map